import { createSlice } from '@reduxjs/toolkit'

const initialStateValue = {
  invoiceId: null,
  mobileNumber: null,
  loading: false,
  authorized: false,
  token: null,
}

export const getInvoiceByEmailSlice = createSlice({
  name: 'getInvoiceByEmail',
  initialState: initialStateValue,
  reducers: {
    setToken: (state, payload) => {
      state.token = payload;
    },
    authenticate: (state, action) => {
      state.authorized = action.payload;
    },
    setUserInvoiceDetails: (state, action) => {
      state.invoiceId = action.payload.InvoiceId;
      state.mobileNumber = action.payload.PhoneNumber;
    },
    setLoading: (state, action) => {
      state.loading = action.payload
    },
    removeDataForInvoiceByEmail: (state, action) => {
      state.invoiceId = action.payload
      state.mobileNumber = action.payload;
      state.token = action.payload;
      state.authorized = false;
      state.loading = false;
    }
  },
})

export const { authenticate, setToken, setUserInvoiceDetails, removeDataForInvoiceByEmail, setLoading } = getInvoiceByEmailSlice.actions

export default getInvoiceByEmailSlice.reducer
